/* MONTHLYACTIVITY */
export const MONTHLYACTIVITYDATA_LIST = 'MONTHLYACTIVITYDATA_LIST';
export const MONTHLYACTIVITYDATA_LIST_SUCCESS = 'MONTHLYACTIVITYDATA_LIST_SUCCESS';
export const MONTHLYACTIVITYDATA_LIST_FAILED = 'MONTHLYACTIVITYDATA_LIST_FAILED';

